import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { MessageService } from './message.service'

@Injectable({ providedIn: 'root' })
export class ApiHelperService {
    msgService = inject(MessageService)

    /**
     * Handles API requests with consistent message handling and loading state
     * @param observable The HTTP request observable
     * @param options Configuration options for the request
     * @returns Subscription
     */
    handleApiRequest<T>(
        observable: Observable<T>,
        options: {
            successMessage?: string
            errorMessage?: string
            onSuccess?: (response: T) => void
            onError?: (error: any) => void
            loadingState?: { loading: boolean }
            customErrorHandler?: (error: { status: number; error: string }) => string | undefined
        } = {}
    ) {
        const {
            successMessage = 'common.saveOk',
            errorMessage = 'common.saveNok',
            onSuccess,
            onError,
            loadingState,
            customErrorHandler,
        } = options

        if (loadingState) {
            loadingState.loading = true
        }

        return observable.subscribe({
            next: (response) => {
                this.msgService.addMessage({
                    message: successMessage,
                    severity: 'success',
                })
                onSuccess?.(response)
            },
            error: (err) => {
                let message = errorMessage

                if (customErrorHandler) {
                    const customMessage = customErrorHandler(err)
                    if (customMessage) {
                        message = customMessage
                    }
                }

                this.msgService.addMessage({
                    message,
                    severity: 'error',
                })
                onError?.(err)
            },
            complete: () => {
                if (loadingState) {
                    loadingState.loading = false
                }
            },
        })
    }
}
